import { useMemo } from 'react';

import { useGameStateSlice } from '@pp/core/src/store/slices/game/selectors';

import { useHighflyerStateSlice } from '../../store/slices/highflyerState/selectors';
import { winStates } from '../../store/slices/highflyerState/types';

export const useWinAmount = (): { winState: winStates; amount: number; playWinSound: boolean } => {
  const cashOutObj = useHighflyerStateSlice.getCashedObj();
  const winResult = useGameStateSlice.winResult();
  const winState = useHighflyerStateSlice.getWinState();
  return useMemo(() => {
    let winAmount = Object.values(cashOutObj).reduce((total, _) => total + _, 0);
    let playWinSound = true;
    if (winResult && winResult?.amount > 0) {
      winAmount = winResult.amount;
      playWinSound = false;
    }
    return {
      winState: winState,
      amount: winAmount,
      playWinSound: playWinSound,
    };
  }, [cashOutObj, winResult, winState]);
};
